import {
  DefaultModalScreenOptions,
  DefaultStackScreenOptions,
  ModalPath,
  TabPath,
} from "@/constants/Navigation";
import { Stack } from "@/crossPlatform/expo-router";
import { useGroupClassDetailsModalDispatch } from "@/store/reducers/modals/groupClassDetailsModal";

const Layout = () => {
  const { resetGroupClassDetailsData } = useGroupClassDetailsModalDispatch();

  return (
    <Stack>
      <Stack.Screen
        name={TabPath.Explore}
        options={DefaultStackScreenOptions}
      />
      <Stack.Screen
        listeners={{
          beforeRemove: () => resetGroupClassDetailsData(),
        }}
        name={ModalPath.GroupClassDetails}
        options={DefaultModalScreenOptions}
      />
    </Stack>
  );
};

export default Layout;
